import axios from 'axios';

export const getRegions = async () => {
  return await axios.get('https://api.bilog.com.ar/api/wappregiones');
};
